import { BasicAuth } from "../configs";


const api = {
  services: {
    sendImportExportServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/import_export/", content),
    sendMigrationServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/migration/", content),
    sendResidenceServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/residency_invest/", content),
    sendBusinessServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/business_buy_sale/", content),
    sendRealEstateServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/real_estate/", content),
    sendConsultingServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/consulting_management/", content),
    sendWorkAbroadServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/work_abroad/", content),
    sendPropertyManagementServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/property_management/", content),
    sendRelocationSupportServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/relocation_support/", content),
    sendMedicalTourismServiceEnquiry: (content) => BasicAuth.post("/pgoverseas/enquiry/medical_support/", content),
    senContactSubmissionDetails: (content) => BasicAuth.post("/pgoverseas/contact_us/", content),
  },
};

const servicesAPI = { ...api };

export default servicesAPI;